import React from 'react';
import { useTranslation } from 'react-i18next';
import { Check, Handshake } from 'lucide-react';

const PKGS = [
  { id: 'p1', items: 3, featured: false },
  { id: 'p2', items: 4, featured: true },
  { id: 'p3', items: 4, featured: false },
];

export default function PackagesSection() {
  const { t } = useTranslation();
  const L = (k) => t(`pages.landing2.packages.${k}`);
  return (
    <section id="paquetes" className="bg-white border-y border-slate-100" data-testid="packages-section">
      <div className="max-w-7xl mx-auto px-6 py-20 lg:py-24">
        <div className="max-w-3xl mb-12">
          <span className="inline-flex items-center gap-2 rounded-full bg-amber-50 border border-amber-200 px-4 py-1.5 text-xs font-semibold text-amber-700">
            <Handshake className="h-3.5 w-3.5" /> {L('eyebrow')}
          </span>
          <h2 className="mt-5 text-3xl sm:text-4xl font-extrabold tracking-tight">{L('heading')}</h2>
          <p className="mt-4 text-slate-600 md:text-lg">{L('sub')}</p>
        </div>
        <div className="grid md:grid-cols-3 gap-6 items-stretch">
          {PKGS.map((p) => (
            <div
              key={p.id}
              className={`rounded-3xl p-8 flex flex-col ${p.featured ? 'text-white shadow-2xl md:scale-[1.02]' : 'bg-[#FDFBF7] border border-slate-200'}`}
              style={p.featured ? { background: 'linear-gradient(160deg,#0F4A4E,#176A70)' } : {}}
              data-testid={`package-${p.id}`}
            >
              {p.featured && <span className="self-start text-[10px] uppercase tracking-wider font-bold rounded-full bg-white/20 px-3 py-1 mb-3">{L('badge')}</span>}
              <h3 className="text-2xl font-extrabold">{L(`${p.id}t`)}</h3>
              <p className={`mt-3 text-sm leading-relaxed ${p.featured ? 'text-teal-100' : 'text-slate-500'}`}>{L(`${p.id}d`)}</p>
              <ul className="mt-6 space-y-2.5 flex-1">
                {Array.from({ length: p.items }, (_, j) => (
                  <li key={j} className={`flex gap-2.5 text-sm ${p.featured ? 'text-teal-50' : 'text-slate-700'}`}>
                    <Check className={`h-4 w-4 mt-0.5 shrink-0 ${p.featured ? 'text-amber-300' : 'text-emerald-600'}`} />
                    {L(`${p.id}i${j + 1}`)}
                  </li>
                ))}
              </ul>
              <a href="#contact" className={`mt-8 rounded-full text-center text-sm font-semibold px-6 py-3 hover:opacity-90 ${p.featured ? 'bg-white text-[#0F4A4E]' : 'bg-[#176A70] text-white'}`} data-testid={`package-cta-${p.id}`}>
                {L('cta')}
              </a>
            </div>
          ))}
        </div>
        <p className="mt-8 text-sm text-slate-500 max-w-3xl" data-testid="packages-custom-note">{L('note')}</p>
      </div>
    </section>
  );
}
